<template>
<div>

    <carousel :autoplay="true" :autoplayTimeout=5000 :speed=900 :loop="true" :per-page="1" :autoplayHoverPause="false" :mouse-drag="false"> <!-- :navigate-to="someLocalProperty" -->
        <slide v-for="img in heroimages" :key="img._id">
            <img :src="'/images/hero/' + img.url" :alt="img.caption">
        </slide>
    </carousel>

    <section class="section">

      <div class="container">

        <div class="columns top-section">
            <div class="column is-two-thirds content">
                <section class="block" v-if="featuredplay">
                    <div>
                        <router-link tag="a" :to="{name: 'play', params: {slug: featuredslug}}">
                            <h1 class="title featuredplay-title">{{ featuredplay.title }}</h1>
                        </router-link>
                        <span class="featuredplay-message tag is-warning is-medium" v-if="featuredplay.message">{{ featuredplay.message }}</span>
                    </div>
                    
                    <router-link tag="a" :to="{name: 'play', params: {slug: featuredslug}}">
                        <img :src="'/images/plays/' + featuredplay.mainimage" :alt="featuredplay.name">
                    </router-link>
          
                    <p class="featuredplay-blurb" v-html="truncatedBlurbLong(featuredplay.blurb)" />

                    <div class="field is-grouped buttons">
                        <div class="control" v-if="featuredplay.buylink">
                            <a class="button is-primary is-medium" :href="featuredplay.buylink">Buy tickets</a>
                        </div>
                        <div class="control" v-if="isStatus('audition')">
                            <router-link :to="{name: 'play-audition', params: {slug: featuredplay.slug}}" class="button is-link is-medium">Apply to audition</router-link>
                        </div>
                        <div class="control">
                            <router-link :to="{name: 'play', params: {slug: featuredslug}}" class="button is-medium">Read more</router-link>
                        </div>
                    </div>

                </section>
            </div>

            <div class="column">
                <aside class="sidebar" v-if="auditionplays.length > 0" >
                    <div class="content">
                    <h3 class="header">
                        Open to auditions
                    </h3>
                    </div>
                    <SidebarCards :items="auditionplays" />
                </aside>
            </div>

        </div>
        
      </div> <!-- end container -->
    </section>

    <div>
      <section class="section grey-block">
        <div class="container content">
          <h3 class="title block-title">
            Future productions
          </h3>
          <div class="block-with-medium-vertical-gap columns" v-for="play in upcomingplays" :key="play._id">
                <div class="column play-image">
                    <router-link :to="{name: 'play', params: {slug: play.slug}}">
                        <img class="bordered-image" :src="'/images/plays/' + play.mainimage" :alt="play.title">
                    </router-link>
                </div>
                
                <div class="column">
                    <router-link :to="{name: 'play', params: {slug: play.slug}}">
                        <h2 class="title featuredplay-title">{{ play.title }}</h2>
                        <span class="featuredplay-message tag is-warning is-medium" v-if="play.message">{{ play.message }}</span>
                    </router-link>
                    <div>
                      <p v-if="play.blurbExcerpt" v-html="play.blurbExcerpt" />
                      <p v-else v-html="truncatedBlurb(play.blurb)" />
                    </div>
                    
                    <div class="block-with-small-vertical-gap-at-top" v-if="play.dates.displayedText && play.dates.displayedText.length > 0">
                      <div class="is-pulled-left">
                          <img src="/images/icons/iconClock.png" srcset="/images/icons/iconClock@2x.png 2x" />
                      </div>
                      <div class="no-image-wrap-small">
                        <div class="block-with-small-vertical-gap-at-bottom" v-for="date in play.dates.displayedText" :key="date.startdate">
                          <div class="dateAndVenueTitle">{{ date.title }}</div>
                          <span class="dateAndVenueDescription">{{ date.description }}</span>
                        </div>
                      </div>
                    </div> 
  
                    <div class="block-with-small-vertical-gap-at-top" v-if="play.venues.length > 0">
                      <div class="is-pulled-left">
                          <img src="/images/icons/iconLocation.png" srcset="/images/icons/iconLocation@2x.png 2x" />
                      </div>
                      <div class="no-image-wrap-small">
                        <div class="block-with-small-vertical-gap-at-bottom" v-for="venue in play.venues" :key="venue._id">
                          <div class="dateAndVenueTitle">Venue</div>
                          <span class="dateAndVenueDescription">{{ venue.name }}, {{ venue.address }}</span>
                        </div>
                      </div>
                    </div> 

                    <div>
                        <div class="field is-grouped buttons">
                            <div class="control">
                                <router-link :to="{name: 'play', params: {slug: play.slug}}" class="button is-transparent">Read more</router-link>
                            </div>
                            <div class="control" v-if="play.status.includes('audition')">
                                <router-link :to="{name: 'play-audition', params: {slug: play.slug}}" class="button is-link">Apply to audition</router-link>
                            </div>
                            <div class="control" v-if="play.buylink">
                                <a class="button is-primary" :href="play.buylink">Buy tickets</a>
                            </div>
                        </div>
                    </div>
                </div>
          </div>

        </div>
      </section>

    </div>
    <div class="lower-section white-block content">

      <section class="section" v-if="blogs">
        <div class="container">
            <h3 class="title block-title">
                Recent blogs
            </h3>
            <div class="block-with-medium-vertical-gap">
                <BlogRows :blogs="blogs.slice(0, 2)" :blogslist="blogs" />
                <router-link class="" tag="a" :to="{name: 'blogs', params: {}}">See all blogs</router-link>
            </div>

        </div>
      </section>
    </div>

</div>
</template>

<script>
//import HeroSlider from './HeroSlider';
//import PlayCards from './cards/PlayCards';
import SidebarCards from './cards/SidebarCards';
import BlogRows from './cards/BlogRows';
import Api from '@/config/Api'
import { Carousel, Slide } from 'vue-carousel';

export default {
    components: {
        //HeroSlider,
        //PlayCards,
        SidebarCards,
        BlogRows,
        Carousel,
        Slide
    },
    data() {
        return {
            featuredplay: {},
            featuredslug: '/',
            heroimages: [],
            plays: [],
            blogs: [],
            upcomingplays: [],
            auditionplays: []
        }
    },
    /*computed: {
        featuredslug() {
            return this.featuredplay.slug;
        }
    },*/
    created() {
        Api().get('/api/plays/featured').then(response => {
            this.featuredplay = response.data;
            this.featuredslug = response.data.slug;
            //console.log("featuredplay created():", this.featuredplay);
            this.$store.commit('setContentLoaded', true); // then footer will be displayed
        });

        Api().get('/api/heros').then(response => {
            this.heroimages = response.data;
            //console.log("heros created():", this.heroimages);
        });

        Api().get('/api/plays').then(response => {
            this.plays = response.data;
            //console.log("plays created():", this.plays);
        });

        Api().get('/api/blogs', {
            headers: {
                itemsperpage: 2 // the # of blogs to display
            }
        }).then(response => {
            this.blogs = response.data.blogs;
            //console.log("blogs created():", this.blogs);
        });

        Api().get('/api/plays/upcomingonhomepage').then(response => {
            this.upcomingplays = response.data;
            //console.log("upcomingplays created():", this.upcomingplays);
        });

        Api().get(`/api/plays/opentoauditions`).then(response => {
            this.auditionplays = response.data.plays;
            //console.log("opentoauditions created", this.auditionplays);
        });

    },
    methods: {
        isStatus(s) {
          if (!this.featuredplay.status) return false;
          return this.featuredplay.status.includes(s);
        },
        truncatedBlurb(blurb) {
            var output = blurb;
            if (blurb) output = this.$options.filters.truncate(blurb, 150)
            // | truncate(160, '...')
            return output;
        },
        truncatedBlurbLong(blurb) {
            var output = blurb;
            if (blurb) output = this.$options.filters.truncate(blurb, 800)
            // | truncate(160, '...')
            return output;
        }
    },
    metaInfo: {
      title: "Combined Actors of Cambridge",
      titleTemplate: null // override the parent template and just use the above title only     
    }
}
</script>

<style scoped>

.play-image {
    padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue